import EnrollForm from './waitlist-form';

export default EnrollForm;
